import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {CommonsModule} from "../../commons/angular/commons.module";
import {TranslateModule} from "@ngx-translate/core";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {NgxPermissionsModule} from "ngx-permissions";
import {GroupsTableComponent} from "./components/groups-table/groups-table.component";
import {GroupsTableRowComponent} from "./components/groups-table-row/groups-table-row.component";
import {
  GroupsColorDisplayListComponent
} from "./components/groups-color-display-list/groups-color-display-list.component";

@NgModule({
  declarations: [
    GroupsTableComponent,
    GroupsTableRowComponent,
    GroupsColorDisplayListComponent
  ],
  imports: [
    BrowserModule,
    ScrollingModule,
    CommonsModule,
    NgbModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild()
  ],
  providers: [],
  exports: [
    GroupsColorDisplayListComponent
  ]
})

export class GroupsModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapGroupsModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(GroupsModule);
};

export const downgradedGroupsModule = downgradeModule(bootstrapGroupsModule);
